import { COLORS } from "../../../styles/variables"

export const MenuPaperStyled = {
    width: "200px",
    borderRadius: '12px',
}

export const MenuListStyled = {
    '& .MuiMenuItem-root': {
        alignSelf: 'start',
        minHeight: "50px",
        height: "40px",
        width: "100%",
        padding: "0px 16px",
        gap: 1,
        fontSize: "14px",
        fontWeight: 400,
    },
    '& .MuiMenuItem-root.Mui-selected': {
        color: COLORS.NICE_BLUE,
        background: `transparent !important`,
        '& .MuiSvgIcon-root': {
            color: COLORS.NICE_BLUE,
        },
    }
}
